import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Mappa path a nome link
  const pathToLinkName = {
    "/admin-dashboard": "dashboard",
    "/admin-userlist": "users",
    "/admin-payments": "payments",
    "/upload-domain": "uploadDomain",
    "/manage-category": "categories",
  };

  // Stato del link attivo basato sul path corrente
  const [activeLink, setActiveLink] = useState(() => {
    return pathToLinkName[location.pathname] || "dashboard";
  });

  useEffect(() => {
        // Se l'utente non è loggato, reindirizza alla homepage
        const adminVariable = localStorage.getItem('admin');
          if (!adminVariable) {
            window.location.href = "/";
            return; // evita che il resto dell'useEffect venga eseguito
          }

    const current = pathToLinkName[location.pathname] || "dashboard";
    setActiveLink(current);
  }, [location.pathname]);

  // Stati hover/click per logout
  const [logoutHover, setLogoutHover] = useState(false);
  const [logoutActive, setLogoutActive] = useState(false);

  const handleLogout = () => {
    // Pulizia token o altre operazioni logout
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user_id");
    window.location.href = "/";
  };

  const menuItems = [
    { name: "dashboard", label: "Dashboard", to: "/admin-dashboard" },
    { name: "users", label: "Utenti", to: "/admin-userlist" },
    { name: "payments", label: "Pagamenti", to: "/admin-payments" },
    { name: "uploadDomain", label: "Domini", to: "/upload-domain" },
    { name: "categories", label: "Categorie", to: "/manage-category" },
  ];

  return (
    <div className="flex flex-col justify-between h-screen bg-[#94c41c] text-white w-64 py-10 shadow-md">
      {/* Sezione Top - Logo o titolo */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold">Admin Panel</h1>
      </div>

      {/* Sezione Centro - Menu */}
      <nav className="flex flex-col space-y-4">
        {menuItems.map(({ name, label, to }) => {
          const isActive = activeLink === name;
          const [hover, setHover] = useState(false);

          return (
            <Link
              key={name}
              to={to}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              className={`
                relative ml-auto w-[80%] cursor-pointer rounded-l-lg
                py-2
                transition-colors duration-300 ease-in-out
                ${
                  isActive
                    ? "bg-white text-[#94c41c] font-semibold"
                    : "bg-[#94c41c] text-white hover:bg-white hover:text-[#94c41c]"
                }
              `}
              style={{ overflow: "hidden" }}
              onClick={() => setActiveLink(name)}
            >
              <span
                style={{
                  display: "block",
                  paddingRight: "1rem",
                  transition: "transform 0.3s ease-in-out",
                  transform:
                    isActive || hover ? "translateX(-10px)" : "translateX(0)",
                }}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </nav>

      {/* Sezione Bottom - Pulsante Logout */}
      <div className="mt-auto flex justify-center mb-4">
        <button
          onClick={handleLogout}
          onMouseEnter={() => setLogoutHover(true)}
          onMouseLeave={() => setLogoutHover(false)}
          onMouseDown={() => setLogoutActive(true)}
          onMouseUp={() => setLogoutActive(false)}
          className={`
            relative ml-auto w-[80%] cursor-pointer rounded-l-lg py-2 
            bg-[#6d4017] text-white font-semibold
            transition-colors duration-300 ease-in-out
            ${logoutHover ? "bg-red-700" : ""}
            ${logoutActive ? "bg-red-800" : ""}
          `}
          style={{
            overflow: "hidden",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <span
            style={{
              display: "block",
              paddingRight: "1rem",
              transition: "transform 0.2s ease-in-out",
              transform: logoutActive
                ? "translateX(-15px)"
                : logoutHover
                ? "translateX(-10px)"
                : "translateX(0)",
            }}
          >
            Log Out
          </span>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
